class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    if (mobileAccordion) {
      if (MinimogTheme.config.mqlMobile) {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      }
      document.addEventListener("matchMobile", () => {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      });
    }

    // Set mobile stickybar height
    if (mobileStickyBar) {
      document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      document.addEventListener("matchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
      document.addEventListener("unmatchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
    }
  }
}
customElements.define("m-footer", MFooter);


(function () {
  const TARGET_SELECTOR = "span[style='cursor: pointer !important;']";
  const CLASS_NAME = "button_span_add_cart";

  function addClassToSpans(root = document) {
    const spans = root.querySelectorAll(TARGET_SELECTOR);
    spans.forEach(span => {
      if (!span.classList.contains(CLASS_NAME)) {
        span.classList.add(CLASS_NAME);
      }
    });
  }

  // 1️⃣ Run once after full page load (DOM + APIs)
  window.addEventListener("load", () => {
    addClassToSpans();
  });

  // 2️⃣ Observe future DOM changes (API / SPA / lazy-loaded content)
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) { // ELEMENT_NODE
          if (node.matches?.(TARGET_SELECTOR)) {
            node.classList.add(CLASS_NAME);
          } else {
            addClassToSpans(node);
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

document.addEventListener("DOMContentLoaded", (event) => {
  console.log("DOM fully loaded and parsed");
  gt_selectors = document.querySelectorAll(".gt_selector");
  gt_selectors.forEach(function(gt_selector){
    custom__imgs = document.querySelectorAll(".custom__img img");
    custom__imgs.forEach(function(custom__img){
      forr = custom__img.getAttribute("data-for");
      if(forr != gt_selector.value){
        custom__img.setAttribute("style", 'display: none;');
      }else{
        custom__img.removeAttribute("style");
      }
    });
    
    gt_selector.addEventListener("change", function(){
      changed_selection = this.value;
      console.clear();
      console.log(changed_selection);
      ccmm__img = document.querySelector("#ccmm__img");
      // if(!ccmm__img){
        if(changed_selection === "en|fr"){
          ccmm__img.setAttribute("src", "https://cdn.shopify.com/s/files/1/0694/5334/8924/files/WhatsApp_Image_2026-02-20_at_11.47.00_PM_1.jpg?v=1771609829")
        }else{
          ccmm__img.setAttribute("src", "https://cdn.shopify.com/s/files/1/0694/5334/8924/files/WhatsApp_Image_2026-02-20_at_11.47.00_PM.jpg?v=1771609827")
        }
      // }
      custom__imgs = document.querySelectorAll(".custom__img img");
      custom__imgs.forEach(function(custom__img){
        forr = custom__img.getAttribute("data-for");
        if(forr != changed_selection){
          custom__img.setAttribute("style", 'display: none;');
        }else{
          custom__img.removeAttribute("style");
        }
      });
    });
  });
});